import React, { memo } from "react";
import { css, useTheme } from "@emotion/react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import client from "pages/includes/apollo";
import Auth from "./Auth";

const AuthPage: React.FC = () => {
    const location = useLocation();
    const theme = useTheme();

    const authPage = css`
        padding-top: ${theme.sizes.menu.heightMain}px;
        font-family: ${theme.fonts.frutiger};
        display: flex;
        flex-direction: column;
        align-items: center;

        ${theme.breakpoints.down("lg")} {
            padding-top: ${theme.sizes.menu.burgerHeightMain}px;
        }
    `;

    return (
        <ApolloProvider client={client}>
            <div css={authPage}>
                <Routes>
                    <Route path={"/login"} element={
                        <Auth
                            key={location.pathname}
                            urls={{
                                socialConfirmationURL: "/auth/social-confirmation",
                                emailVerificationURL: "/auth/email-verification",
                                successURL: "/manage",
                            }}
                        />}
                    />
                </Routes>
            </div>
        </ApolloProvider>
    );
};

export default memo(AuthPage);